/**
 * 'AuthLogin Model'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default {
  model (resource) {
    return Object.assign({
      email: '',
      password: '',
      rememberMe: false
    },
    resource
    )
  },
  rules (model = {}) {
    return {
      email: [
        {required: true, message: 'El usuario es requerido', trigger: 'blur'},
        { type: 'email', message: 'Ingrese una dirección de correo correcta', trigger: 'blur' }
      ],
      password: [
        {required: true, message: 'El password es requerido', trigger: 'blur'},
        {min: 6, message: 'Su password debe contener al menos 6 caracteres', trigger: 'blur'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/auth-sign-in.model.js